module.exports = __webpack_public_path__ + "static/media/nodata.9d0121f3.svg";